import React, { useState } from "react";
import { MapPin, Phone, Clock } from "lucide-react";
import { clinic, workingHoursText } from "../data";
import LegalDocModal from "./LegalDocModal";

export default function Footer() {
  const [legal, setLegal] = useState(null);

  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <p className="footer-about">
              Клиника без белых халатов и клинической атмосферы. Лечим без страха, работаем честно, отвечаем за результат гарантией.
            </p>
          </div>

          <div className="footer-col">
            <h4>Услуги</h4>
            <ul>
              <li><a href="#usp">Имплантация зубов</a></li>
              <li><a href="#prices">Цена под ключ</a></li>
              <li><a href="#usp">Лечение под седацией</a></li>
              <li><a href="#process">Этапы лечения</a></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Разделы</h4>
            <ul>
              <li><a href="#doctors">Врачи</a></li>
              <li><a href="#social">Отзывы</a></li>
              <li><a href="#faq">FAQ</a></li>
              <li><a href="#final">Записаться</a></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Контакты</h4>
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              <div className="footer-contact-item">
                <MapPin size={16} />
                <span>{clinic.address}, {clinic.city}</span>
              </div>
              <div className="footer-contact-item">
                <Phone size={16} />
                <a href={`tel:${clinic.phoneRaw}`}>{clinic.phone}</a>
              </div>
              <div className="footer-contact-item">
                <Clock size={16} />
                <span>{workingHoursText}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div>
            © {new Date().getFullYear()} {clinic.name}. Лицензия на медицинскую деятельность {clinic.license}
          </div>
          <div style={{ display: "flex", gap: 18, flexWrap: "wrap" }}>
            <button type="button" className="link-btn footer-legal-link" onClick={() => setLegal("privacy")} data-testid="footer-privacy-link">
              Политика конфиденциальности
            </button>
            <button type="button" className="link-btn footer-legal-link" onClick={() => setLegal("consent")} data-testid="footer-consent-link">
              Согласие на обработку ПД
            </button>
          </div>
        </div>
      </div>

      <LegalDocModal open={!!legal} docKey={legal} onClose={() => setLegal(null)} />
    </footer>
  );
}
